

export let getBranch = `query getBranch($OperationList:[OperationList]) 
{
    getBranch(OperationList: $OperationList) 
    {
        OfficeName
        OfficeShortName
        CountryGuid
        CurrencyGuid
        LocationGUID
        GroupGuid
        LanguageGuid
        IsActive
        Timestamp
        IsBranch
    }
}`;

export let getBranchById = `query getBranchById($LocationGUID:String){
    getBranchById(LocationGUID:$LocationGUID) {   
        OfficeName
        OfficeShortName
        OfficePlace
        OfficeDistrict
        PostBox
        OfficeAddress
        CountryGuid
        IsActive
        Timestamp
        IsDefault
        Telephone{
            CountryCode
            AreaCode
            Number
            Extension
        }
        CellPhone{
            CountryCode
            AreaCode
            Number
        }
        IsBranch
        CurrencyGuid
        LocationGUID
        StateGuid
        AccountNo
      TRN
        BankInfo
        GroupGuid
        LanguageGuid
    }
}`;

export var createBranchConfigurator = `mutation createBranchConfigurator($data: InputStepFunctionBranch) {
    createBranchConfigurator(data: $data)
    {
        OfficeName
        OfficeShortName
        CountryGuid
        CurrencyGuid
        LocationGUID
        GroupGuid
        LanguageGuid
        IsActive
        Timestamp
        IsBranch
    }
  }`;

export var updateBranch = `mutation updateBranch($data: InputStepFunctionBranch) {
    updateBranch(data: $data)
    {
        OfficeName
        OfficeShortName
        CountryGuid
        CurrencyGuid
        LocationGUID
        GroupGuid
        LanguageGuid
        IsActive
        Timestamp
        IsBranch
    }
}`;

export const deleteBranch = `mutation deleteBranch($data: InputStepFunctionBranch) 
{
    deleteBranch(data: $data)
}`;

export const getBranchByLanguageIdAndGroupId = `query getBranchByLanguageIdAndGroupId($OperationList: [OperationList]) {
    getBranchByLanguageIdAndGroupId(OperationList: $OperationList) {  
        OfficeName
        OfficeShortName
        CountryGuid
        CurrencyGuid
        LocationGUID
        GroupGuid
        LanguageGuid
        IsActive
        Timestamp
        IsBranch
    }
  }`;